import { SESSION_ID } from '../../../config/session-id';
import { ua } from '../../../util/user-agent';
import { u2f } from '../../lib/u2f-api';

export class Controller {

    /** @ngInject */
    constructor(
        $http,
        $rootScope,
        $scope,
        $timeout,
        Alert,
        BarcodeGeneratonService,
        HardTokenResource,
    ) {
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.Alert = Alert;
        this.BarcodeGeneratonService = BarcodeGeneratonService;
        this.HardTokenResource = HardTokenResource;
    }

    $onDestroy() {
        this.isModalOpen = false;
    }

    $onInit() {
        this.isModalOpen = true;
        const {titleKey, textKey, http} = this.resolve.config;
        this.titleKey = titleKey || 'destructive_operation.enter_onetime_password';
        this.textKey = textKey;
        this.http = http;
        this.otp = '';
        this.isSmsUser = this.$rootScope.account.roles.includes('ROLE_SMS_USER');

        this.$scope.$on('websocket.LOGIN', (event, data) => {
            this.sendRequest('tracker', data.password);
        });

        // this.isMacOS = ua.isMacOS();
        // Proximity removed by Faking the user agent check
        this.isMacOS = false;

        this.initializeHardTokens();
    }

    activateProximity() {
        this.proximityActivated = true;
        this.$timeout(3000).then(() => this.proximityActivated = false);
    }

    initializeHardTokens() {
        const {roles, isSecondaryDeviceSession} = this.$rootScope.account;
        this.isHardTokenUser = roles.includes('ROLE_HARD_TOKEN_USER') || isSecondaryDeviceSession;

        if (!this.isHardTokenUser) {
            return;
        }

        this.isLoading = true;
        this.HardTokenResource
            .u2fLoginStart(this.$rootScope.account.login)
            .then(data => {
                this.u2fSignRequests = data.authenticateRequests;
                this.isU2fAvailable = true;
                this.selectTab('u2f');
                this.signU2f();
            })
            .catch(() => {
                this.isU2fAvailable = false;
                this.selectTab('usb');
            })
            .finally(() => this.isLoading = false)
    }

    loadQrData() {
        return this.BarcodeGeneratonService
            .get({uuid: `#V#${SESSION_ID}`}).$promise
            .then(({bluetoothcode, barcodeimage}) => {
                this.bluetoothCode = bluetoothcode;
                return barcodeimage;
            });
    }

    saveDisabled(form) {
        return form.$invalid || this.isLoading || this.isSaving || this.selectedTab === 'u2f';
    }

    selectTab(tabName) {
        this.otp = '';
        this.selectedTab = tabName;
    }

    sendRequest(passwordType, password) {
        this.isSaving = true;
        if (this.resolve.config.onSubmit) {
            return this.resolve.config.onSubmit({[passwordType]: password})
                .then((response) => this.close({$value: response}))
                .finally(() => this.isSaving = false)
        }
        this.$http({...this.http, params: {...this.http.params, [passwordType]: password}})
            .then(({data}) => this.close({$value: data}))
            .finally(() => this.isSaving = false)
    }

    signU2f() {
        u2f.sign(this.u2fSignRequests, ({errorCode, ...signResponse}) => {
            if (!this.isModalOpen) {
                return;
            }
            this.$scope.$apply(() => {
                if (errorCode) {
                    if (this.selectedTab === 'u2f') {
                        this.Alert('danger', `hard_token_login.messages.error.ERROR_${errorCode}`)
                    }
                    this.u2fSignatureTimedOut = errorCode === 5;
                } else {
                    this.sendRequest('u2f', JSON.stringify(signResponse))
                }
            });
        });
        this.u2fSignatureTimedOut = false;
    }

    submit() {
        this.sendRequest(this.isSmsUser ? 'pin' : 'otp', this.otp);
    }
}



// WEBPACK FOOTER //
// ./src/portal/modals/destructive-operation/destructive-operation.controller.js